<div class="me-landing-page-data">
    <div tabindex="0" class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="me-landing-page-data__icon">
                    <img src="{{data.icon.filename}}">
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-landing-page-data__header" [innerHTML]="data.headline | storyblokRichtext"></div>
            </div>
            <div class="col-xs-12">
                <div class="me-landing-page-data__body">
                    <div class="me-landing-page-data__grid">
                        <div *ngFor="let list of data.list" class="me-landing-page-data__grid-content">
                            <div class="grid-content__value">{{list.value}}</div>
                            <div class="grid-content__headline">{{list.headline}}</div>
                            <div class="grid-content__text">{{list.text}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-landing-page-data__source">
                    <i class="fal fa-info-circle"></i>
                    <storyblok-link [data]="data.source" [classList]="'text-white'"></storyblok-link>
                </div>
            </div>
        </div>
    </div>
</div>
